import iPhone from './images/products/mobiles/IPhone14.png'
import pixel7 from './images/products/mobiles/pixel7.jpg'
import xiomi12 from './images/products/mobiles/xiomi12.jpg'
import samsungs22 from './images/products/mobiles/samsungs22.jpg'
import opporeno8 from './images/products/mobiles/opporeno8.jpg'
import iq007 from './images/products/mobiles/iq007.jpg'
import honorMagic3 from './images/products/mobiles/honorMagic3.png'
import nothingPhone from './images/products/mobiles/nothingPhone.jpg'


const products = [
    {
        id: 0,
        name: 'I Phone 14',
        desc: ['256 GB ROM','15.49 cm (6.1 inch) Super Retina XDR Display','12MP + 12MP | 12MP Front Camera','A15 Bionic Chip, 6 Core Processor Processor'
        ],
        price: 79900,
        image: iPhone,
        piece: 1,
    },
    {
        id: 1,
        name: 'Google Pixel 7',
        desc: ['8 GB RAM | 128 GB ROM','16.0 cm (6.3 inch) Full HD+ Display','50MP + 12MP | 10.8MP Front Camera','4270 mAh Battery','Google Tensor G2 Processor'
        ],
        price: 59999,
        image: pixel7,
        piece: 1,
    },
    {
        id: 2,
        name: 'Xiomi 12 Pro',
        desc: ['12 GB RAM | 256 GB ROM','17.09 cm (6.73 inch) Full HD+ AMOLED Display','50MP Rear Camera','4600 mAh Battery','Snapdragon@ 8 Gen 1 Processor'
        ],
        price: 67499,
        image: xiomi12,
        piece: 1,
    },
    {
        id: 3,
        name: 'Samsung S22',
        desc: ['8 GB RAM | 256 GB ROM','5.49 cm (6.1 inch) Full HD+ Display','50MP + 12MP + 10MP | 10MP Front Camera','3700 mAh Lithium-ion Battery','Octa Core Processor'
        ],
        price: 62999,
        image: samsungs22,
        piece: 1,
    },
    {
        id: 4,
        name: 'Oppo Reno 8',
        desc: ['8 GB RAM | 128 GB ROM','16.33 cm (6.43 inch) Full HD Display','50MP + 8MP + 2MP | 32MP Front Camera','4500 mAh Lithium-ion Polymer Battery','Mediatek Dimensity 1300 Processor'
        ],
        price: 29999,
        image: opporeno8,
        piece: 1,
    },
    {
        id: 5,
        name: 'iQOO7',
        desc: 'very nice phone',
        price: 29990,
        image: iq007,
        piece: 1,
    },
    {
        id: 6,
        name: 'Honor Magic3',
        desc: ['12 GB RAM | 256 GB ROM','16.81 cm (6.62 inch) Display','48MP + 48MP + 13MP + 2MP | 16MP + 16MP Dual Front Camera','4440 mAh Battery'
        ],
        price: 52790,
        image: honorMagic3,
        piece: 1,
    },
    {
        id: 7,
        name: 'Nothing Phone',
        desc: ['8 GB RAM | 128 GB ROM','16.64 cm (6.55 inch) Full HD+ Display','50MP + 50MP | 16MP Front Camera','4500 mAh Lithium-ion Battery','Qualcomm Snapdragon 778G+ Processor','Meet the Glyph Interface. A New Way to Communicate','1 Billion Colours, True-to-Life Full HD Flexible OLED Display with HDR10+ for Richer Colour and Deeper Contrasts'
        ],
        price: 32999,
        image: nothingPhone,
        piece: 1,
    },

]

export default products